/* eslint-disable react/prop-types */
import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import UsuarioContext from '../../context/usuario.context';
import FirebaseContext from '../../context/firebase.context';
import CidadesContext from '../../context/cidades.context';
import { HeaderOptions } from './novoCadastro/header';
import ModalBody from './novoCadastro';
import { FormataTelefone } from '../../functions/helper';
import Inbox from './inbox';
import Cadastros from './cadastrosAtivos';
import CadastrosAdmin from './cadastrosAtivosAdmin';
import CadastrosInAdmin from './cadastrosInativosAdmin';
import './modals.scss';
import './meusDados.scss';
import NotificarUsuarios from './notificarUsuarios';
import AtribuirNovoCadastro from './atribuirNovoCadastro';
import Apresentar from './apresentar';
import ModalCertificado from './certificado';
import ModalVendas from './vendas';

export function LogoutModal() {
  const { usuario: { nome } } = useContext(UsuarioContext);
  const { Logout } = useContext(FirebaseContext);
  return (
    <div className="modal fade" id="modal-logout" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">Encerrar Sistema ?</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <span>
              {`Deseja encerrar seu acesso ${nome}? Caso tenha informações não salvas elas serão perdidas.`}
            </span>
          </div>
          <div className="modal-footer">
            <button onClick={() => Logout()} type="button" data-dismiss="modal" className="btn btn-dark">Fazer Logout</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function NovoCadastro() {
  const { usuario: { uid } } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-novo-cadastro" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title" id="exampleModalLongTitle">Inserir novo registro</h6>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {uid && <HeaderOptions />}
            {uid && <ModalBody />}
          </div>
          <div id="info-modal" className="modal-footer">
            <span>
              *A
              {' '}
              <strong>&quot;Visibilidade&quot;</strong>
              {' '}
              das suas “áreas
              de risco” cadastradas no mapa, localização e dados para contato
              serão exibidas de forma seletiva seguindo as suas preferencias.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function MeusDados() {
  const [desabilitado, setDesabilitado] = useState(true);
  const {
    listCity, listUf, handleChange: handleChangeCity, findLocationWhithUf,
  } = useContext(CidadesContext);
  const { usuario, setUsuario } = useContext(UsuarioContext);
  const { UpdateUser } = useContext(FirebaseContext);

  useEffect(() => {
    findLocationWhithUf(usuario.estado);
  }, [usuario.estado]);

  function updateUser() {
    if (!desabilitado) {
      return UpdateUser({ update: true, setDesabilitado });
    }
    return setDesabilitado((prevState) => !prevState);
  }

  function handleChange({ target }) {
    const { name, value } = target;
    const change = name === 'fone' || name === 'celular' ? FormataTelefone(value) : value;
    setUsuario((prevState) => ({
      ...prevState, [name]: change,
    }));
  }

  return (
    <div className="modal fade" id="modal-meus-dados" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title" id="exampleModalLongTitle">Dados cadastrais</h6>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <label id="label-nome" className="nome">
              <span>
                Nome
              </span>
              <input
                onChange={handleChange}
                type="text"
                required
                disabled={desabilitado}
                id="nome"
                name="nome"
                placeholder="Nome"
                value={usuario.nome}
              />
            </label>
            <label id="label-fone" className="fone">
              <span>
                Telefone
              </span>
              <input
                onChange={handleChange}
                type="text"
                required
                disabled={desabilitado}
                id="fone"
                name="fone"
                placeholder="Telefone"
                value={usuario.fone}
              />
            </label>
            <label id="label-celular" className="celular">
              <span>
                Celular
              </span>
              <input
                onChange={handleChange}
                type="text"
                required
                disabled={desabilitado}
                id="celular"
                name="celular"
                placeholder="celular"
                value={usuario.celular}
              />
            </label>
            <label id="label-estado" className="estado">
              <span>
                Informe Estado
              </span>
              <select
                className="form-control"
                id="estado"
                name="estado"
                disabled={desabilitado}
                required
                onChange={handleChangeCity}
              >
                <option disabled selected value>
                  -- ESTADO --
                </option>
                {listUf.map((a) => (
                  <option selected={a.sigla === usuario.estado} value={a.id}>{a.nome}</option>
                ))}
              </select>
            </label>
            <label id="label-cidade" className="cidade">
              <span>
                Informe a cidade
              </span>
              <select
                className="form-control"
                name="cidade"
                id="cidade"
                required
                disabled={desabilitado}
                onChange={handleChangeCity}
              >
                {listCity.map((a) => (
                  <option
                    selected={a.nome === usuario.cidade}
                    value={a.nome}
                  >
                    {a.nome}
                  </option>
                ))}
              </select>
            </label>
            <label id="label-focpfCnpjne" className="cpfCnpj">
              <span>
                CPF/CNPJ
              </span>
              <input
                onChange={handleChange}
                type="text"
                name="cpfCnpj"
                id="cpfCnpj"
                disabled
                required
                placeholder="(00)0000-0000"
                value={usuario.cpfCnpj}
              />
            </label>
            <label id="label-endereco" className="endereco">
              <span>
                Endereço
              </span>
              <input
                onChange={handleChange}
                type="text"
                required
                name="endereco"
                id="endereco"
                disabled={desabilitado}
                placeholder="ex. Rua 1º de Maio"
                value={usuario.endereco}
              />
            </label>
            <label id="label-bairro" className="bairro">
              <span>
                Bairro
              </span>
              <input
                onChange={handleChange}
                type="text"
                required
                name="bairro"
                disabled={desabilitado}
                id="bairro"
                placeholder="ex. Centro"
                value={usuario.bairro}
              />
            </label>
            <label id="label-complemento" className="complemento">
              <span>
                Complemento
              </span>
              <input
                onChange={handleChange}
                type="text"
                name="complemento"
                id="complemento"
                disabled={desabilitado}
                placeholder="ex. Apto 15"
                value={usuario.complemento}
              />
            </label>
            <label id="label-inscricao" className="inscricao">
              <span>
                Inscrição Municipal
              </span>
              <input
                onChange={handleChange}
                type="text"
                name="inscricao"
                disabled={desabilitado}
                id="inscricao"
                placeholder="Informe o Nº"
                value={usuario.inscricao}
              />
            </label>
            <label id="label-website" className="site">
              <span>
                Website
              </span>
              <input
                onChange={handleChange}
                type="text"
                disabled={desabilitado}
                name="site"
                id="site"
                placeholder="www.meusite.com.br"
                value={usuario.site}
              />
            </label>
            <label id="label-empresa" className="empresa">
              <span>
                Informação Adicional
              </span>
              <input
                onChange={handleChange}
                type="text"
                disabled={desabilitado}
                name="empresa"
                id="empresa"
                placeholder="Nome da Empresa, Organização Pública ou Associação vinculado (Opcional)"
                value={usuario.empresa}
              />
            </label>
          </div>
          <div className="modal-footer">
            <button
              onClick={() => updateUser()}
              type="button"
              className="btn btn-dark btn-sm"
            >
              {
              desabilitado ? 'Habilitar Campos' : 'Atualizar Dados'
            }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function TermosDeUso({ aceite: { show } }) {
  const { setAcepted } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-termos-de-uso" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">Termos de Uso AGSAFE</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <span className="text-justify">
              O uso dos sites “AGSAFE”
              (agsafe.com.br) e
              “AGASEAPP”
              (agasafeapp.com) constitui sua concordância com todos os seguintes termos e condições,
              cujos termos e condições estão sujeitos a alterações sem aviso prévio. Se você não
              concordar com estes termos e condições, seu único recurso é interromper o uso do site.
            </span>
            <span className="text-justify">
              Sem garantias: os dados e materiais relacionados e informações fornecidas no site são
              fornecidos &quot;como estão&quot; e &quot;conforme disponíveis&quot;.
              {' '}
              AGSAFE
              {' '}
              não fornece quaisquer garantias, representações ou condições
              expressas ou implícitas de
              qualquer tipo em relação ao site, o conteúdo, precisão, atualidade ou integridade do
              mesmo, ou sobre os resultados a serem obtidos a partir de consultas ou uso do site.
              {' '}
              AGSAFE
              {' '}
              isenta-se de todas as garantias e representações de qualquer tipo em relação ao site,
              incluindo, mas não se limitando a, quaisquer garantias implícitas de comercialização,
              não violação de direitos de terceiros, liberdade de vírus ou outro código prejudicial,
              ou adequação a qualquer propósito particular.
            </span>
            <span className="text-justify">
              Você é responsável por garantir a precisão, atualidade e outras qualidades de todas as
              informações
              (incluindo, mas não se limitando a, mapas, relatórios,
              exibições e análises)
              produzidas a partir de ou em conexão com o Site, e você assume todos os riscos
              associados a ele. Além disso, você é responsável por seguir todas as leis e
              regulamentos federais, estaduais e locais com relação ao uso de pesticidas,
              incluindo quaisquer leis ou regulamentos estaduais ou locais que possam abordar
              o uso do Site. Você reconhece e concorda que quaisquer dados e materiais relacionados
              e informações que você fornecer ao Site foram fornecidos voluntariamente,
              independentemente de tais materiais poderem ser considerados informações
              privadas ou confidenciais.
            </span>
            <span className="text-justify">
              Limitação de responsabilidade:
              {' '}
              exceto conforme previsto neste documento, nenhum usuário, produtor ou aplicador
              terá qualquer remédio contra o
              {' '}
              AGSAFE
              {' '}
              se os dados fornecidos ou omitidos do site forem defeituosos de qualquer forma,
              incluindo, mas não se limitando à recuperação de consequências, incidentais ou
              danos indiretos, danos punitivos, lucros cessantes, oportunidades perdidas ou
              quaisquer outros danos alegadamente sofridos por tal pessoa ou qualquer outra
              pessoa como resultado do uso, mau uso ou falha no uso do Site. Além disso,
              {' '}
              AGSAFE
              {' '}
              não será responsável por qualquer atraso, dificuldade de uso, inexatidão
              de informações, vírus de computador, código malicioso ou outros defeitos no
              site, ou por qualquer incompatibilidade entre o site e seu navegador de Internet
              ou outro programa de acesso ao site, nem
              {' '}
              AGSAFE
              {' '}
              será responsável por quaisquer outros problemas que você enfrentar
              devido a causas além do seu controle.
            </span>
            <span className="text-justify mt-3">
              Indenização:
              {' '}
              Você concorda em defender, indenizar e isentar de responsabilidade
              {' '}
              AGSAFE
              {' '}
              e seus respectivos afiliados, funcionários, contratados, agentes, diretores,
              executivos e membros, de todas e quaisquer perdas, responsabilidades,
              reivindicações, demandas, julgamentos e despesas (incluindo honorários advocatícios)
              decorrentes fora de ou de alguma forma conectado ao seu uso do site ou como resultado
              do seu não cumprimento destes termos e condições.
            </span>
            <span className="text-justify">
              Interrupção do serviço:
              {' '}
              Em caso de falha ou interrupção do sistema, incluindo, mas
              não se limitando a, um caso fortuito, falha de hardware /
              software ou sobrecarga do sistema, os dados do site podem
              ser perdidos ou destruídos. Quaisquer resultados obtidos de
              consultas concluídas ou em andamento no Site antes de uma
              falha ou interrupção do sistema devem ser verificados por
              você para garantir a precisão e integridade de tais resultados.
              Você assume o risco de perda de seus resultados durante qualquer
              falha ou interrupção do sistema, bem como a responsabilidade de
              verificar a precisão e integridade de quaisquer resultados assim afetados.
            </span>
            <p className="text-justify mt-4">Se você tiver alguma dúvida sobre este site, entre em contato conosco pelo e-mail info@agsafe.com.br.</p>
            <p className="text-justify">Termos de Uso</p>
            <p className="text-justify">Data: 28 de janeiro de 2021</p>
            <span className="text-justify">AGSAFE Ltda. (“AGSAFE”) fornece serviços online através de diferentes sites (www.AGSAFE.com.br; www.AGSAFEAPP.com; www.AGSAFE.co), (juntos, o “Site”) que estão sujeitos a estes Termos de Uso (“Termos”). Ao usar o site, você concorda com estes termos.</span>
            <span className=" text-justify">
              Serviços AGSAFE.
              O site AGSAFE e os aplicativos de smartphone associados
              fornecem aos usuários online e móveis acesso à localização
              e informações de contato fornecidas pelo Registro AGSAFE e
              Registro AGSAFEAPP (juntos, os “Registros AGSAFE”). O site
              AGSAFE, os aplicativos móveis AGSAFE App e os registros AGSAFE
              associados constituem os “Serviços” AGSAFE.
            </span>
            <ul className="">
              <li className=" text-justify">
                {' '}
                <p>
                  Registro AGSAFE.
                  {' '}
                  AGSAFE hospeda e mantém um registro da localização
                  de culturas especiais, certificadas, em processo de
                  certificação, organismos não alvo, moradias isoladas
                  e demais pontos de interesse que componham o seu proposito.
                  Proprietários e produtores de culturas especiais, criadores
                  de organismos não alvo assim como residentes em moradias
                  isoladas podem fazer upload da descrição e localização nas
                  plataformas e aplicativos AGSAFE e AGSAFEAPP após obter uma
                  conta de usuário. As plataformas e aplicativos AGSAFE e
                  AGSAFEAPP permitem que aplicadores de pesticidas comerciais,
                  aplicadores de pesticidas particulares e aplicadores de produtores
                  se registrem como usuários dos Serviços. As informações do aplicador
                  são mantidas pelo Registro AGSAFE e AGSAFEAPP
                  {' '}
                  (“Registro AGSAFE”)
                  .
                </p>
              </li>
              <li className=" text-justify">
                {' '}
                <p>
                  Mapas AGSAFE e AGSAFEAPP.
                  {' '}
                  Agricultores, consultores agrícolas, varejistas agrícolas,
                  fornecedores e aplicadores de pesticidas podem usar
                  os sites AGSAFE e AGSAFEAPP para acessar a localização
                  de culturas especiais, certificadas, em processo de
                  certificação, organismos não alvo, moradias isoladas e
                  demais pontos de interesse que componham o seu proposito
                  outras informações dos Registros AGSAFE e AGSAFEAPP que
                  são exibidos nos Sites AGSAFE e AGSAFEAPP em mapa, lista
                  e outros formatos (o “Mapa AGSAFE”). AGSAFE pode limitar
                  as informações que podem ser visualizadas no mapa AGSAFE
                  a critério do AGSAFE.
                </p>
              </li>
              <li className=" text-justify">
                {' '}
                <p>
                  Aplicativos AGSAFE.
                  {' '}
                  O AGSAFE pode incluir uma versão para smartphone do site
                  AGSAFE ou aplicativo separado para smartphones incorporando
                  os Serviços (“AGSAFE App”). O uso dos AGSAFE Apps está sujeito
                  a estes Termos e também pode estar sujeito a termos adicionais.
                </p>
              </li>
            </ul>

            <li className=" text-justify">
              Sua conta.
              {' '}
              Os Serviços AGSAFE fornecem informações de nível básico
              no Mapa AGSAFE para qualquer usuário do Site. Recursos
              adicionais estão disponíveis para usuários que se registram
              para acessar um ou mais dos Registros AGSAFE e Mapa AGSAFE
              criando uma conta com um ID e senha exclusivos, fornecendo
              informações adicionais e concordando em obedecer à
              {' '}
              Isenção de Responsabilidade de Uso do AGSAFE
              {' '}
              (“Usuários Registrados”). As informações pessoais
              coletadas ao criar uma conta também estão sujeitas à
              {' '}
              Política de Privacidade do AGSAFE
              . AGSAFE pode encerrar a conta de qualquer usuário registrado por qualquer motivo.
            </li>
            <ul className="">
              <li className=" text-justify">
                {' '}
                <p>
                  Mensagem de Texto (SMS).
                  {' '}
                  Ao criar uma Conta, você concorda que os Serviços poderão
                  lhe enviar mensagens de textos (SMS) e mensagens diretas
                  via Whatsapp como parte das operações comerciais regulares
                  para o uso dos Serviços. Você poderá optar por não receber
                  mensagens de texto (SMS) da AGSAFE a qualquer momento,
                  seguindo as instruções indicadas em capo especifico da
                  plataforma. Você reconhece que optar por não receber as
                  mensagens de texto poderá prejudicar o seu uso dos Serviços.
                </p>
              </li>
              <li className=" text-justify">
                {' '}
                <p>
                  Avisos.
                  {' '}
                  A AGSAFE poderá enviar avisos por meio de notificações gerais nos
                  Serviços, correio eletrônico para seu endereço de e-mail em
                  sua Conta, ou por comunicação escrita enviada ao endereço
                  indicado em sua Conta.
                </p>
              </li>
            </ul>

            <li className=" text-justify">
              <p>
                Envios do usuário.
                {' '}
                Os Usuários Registrados podem carregar informações sobre
                a localização e tipo de cultura e criação de organismos
                não alvo nos diferentes Registros AGSAFE, conforme aplicável.
                Cada envio de um usuário é considerado um “Envio do usuário”.
                Você garante que está autorizado a fazer upload de cada Envio do
                usuário fornecido e que cada Envio do usuário é verdadeiro,
                preciso e não enganoso. O upload intencional de Envios de
                usuário falsos ou imprecisos pode causar o encerramento de
                sua conta. Você concede ao AGSAFE uma licença ilimitada
                para usar as informações enviadas nos Envios do Usuário
                para fornecer os Serviços AGSAFE a outros usuários,
                incluindo a integração do Mapa AGSAFE e informações
                derivadas dos Registros AGSAFE em outras plataformas
                online que foram aprovadas pelo AGSAFE. Você não pode
                carregar vírus, spyware ou outro software malicioso
                no AGSAFE. O uso dos Serviços deve ser sempre legal.
                AGSAFE pode alterar ou excluir qualquer Envio do
                Usuário sem recorrer a você.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Visualizando o Mapa AGSAFE.
                {' '}
                Qualquer usuário do site pode visualizar o mapa AGSAFE; Os
                usuários registrados podem visualizar camadas adicionais de
                dados no mapa AGSAFE, conforme determinado pelo AGSAFE. Você
                não deve confiar no Mapa AGSAFE apenas para determinar a
                localização de culturas especiais, certificadas, em processo
                de certificação, organismos não alvo, moradias isoladas e
                demais pontos de interesse que componham o seu proposito.
                O AGSAFE Map pretende ser uma ferramenta útil para informar
                os agricultores, consultores de cultura e aplicadores de
                pesticidas. AGSAFE não faz nenhuma representação quanto à
                veracidade ou precisão de qualquer informação contida nos
                Envios do usuário. As camadas de fundo para o Mapa AGSAFE são
                fornecidas pelo
                {' '}
                Google Maps.
                {' '}
                Portanto, a visualização e o uso do AGSAFE Map estão sujeitos aos
                {' '}

                Termos de Serviço do Google e aos Termos de Serviço
                Adicionais do Google Maps / Google Earth.

              </p>
            </li>
            <li className=" text-justify">
              Restrições gerais de uso.
              {' '}
              AGSAFE concede a você permissão para acessar e usar os Serviços,
              sujeito às seguintes condições:
            </li>

            <ul className="">
              <li className=" text-justify"> Você não deve alterar ou modificar qualquer parte dos Serviços.</li>
              <li className=" text-justify"> Você não deve (ou tentar) contornar, desabilitar ou interferir de outra forma com quaisquer recursos relacionados à segurança dos Serviços.</li>
              <li className=" text-justify"> Você não deve solicitar nenhum Usuário Registrado cujo nome ou endereço seja identificado pelo uso dos Serviços.</li>
              <li className=" text-justify"> Você não deve acessar os Envios do usuário para qualquer fim que não seja para fazer a aplicação de pesticidas ou outros fins agrícolas.</li>
              <li className=" text-justify"> Você não deve copiar, reproduzir, distribuir, transmitir, transmitir, exibir, vender, licenciar ou de outra forma explorar qualquer Material do Usuário para quaisquer outros fins sem o consentimento prévio por escrito do AGSAFE.</li>
              <li className=" text-justify"> Nada nessas restrições deve limitar sua capacidade de acessar os Envios do Usuário de outra fonte legal, como outra plataforma de dados da qual você é um assinante, desde que essa fonte tenha se integrado aos Serviços com permissão.</li>
              <li className=" text-justify"> Se você deseja integrar os Serviços em uma plataforma separada, você deve concordar com os termos adicionais fornecidos pelo AGSAFE para tal fim. Todas as integrações e downloads dos Envios do usuário devem ser autorizados pelo AGSAFE.</li>
              <li className=" text-justify">
                {' '}
                <p>
                  Você não deve violar os

                  Termos de Serviço do Google, os Termos de Serviço
                  Adicionais do Google Maps / Google Earth

                  {' '}
                  ou qualquer outro requisito do Google aplicável ao Mapa AGSAFE.
                </p>
              </li>
            </ul>

            <li className=" text-justify">
              <p>
                Condições de pagamento.
                {' '}
                O uso dos Serviços para usuários não registrados é gratuito. O
                AGSAFE pode cobrar uma taxa para determinados Usuários Registrados,
                a critério do AGSAFE e com aviso prévio.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Marcas registradas e propriedade intelectual.
                {' '}
                Estes Termos não concedem a você nenhum direito, título ou
                interesse nos nomes “AGSAFE”, “AGSAFE App” ou quaisquer outros
                nomes ou logotipos de propriedade AGSAFE (“Marcas”). Você não
                pode usar as marcas registradas, a menos que autorizado pelo
                AGSAFE. Você concorda em pagar os honorários advocatícios
                incorridos pela AGSAFE para fazer cumprir esta disposição.
                Estas restrições ao uso de marcas registradas AGSAFE não
                se aplicam aos sinais AGSAFE usados para designar áreas
                apropriadas.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Rescisão.
                {' '}
                AGSAFE reserva-se o direito de suspender ou encerrar sua conta
                de Usuário Registrado e uso dos Serviços a qualquer momento, sem
                justa causa, sem aviso prévio e sem responsabilidade para com
                você. O AGSAFE pode suspender ou encerrar sua conta se você não
                estiver cumprindo com estes Termos ou usando os Serviços de
                qualquer forma que possa causar responsabilidade legal do
                AGSAFE ou interromper o uso dos Serviços por terceiros.
                Todas as provisões de indenização e responsabilidade nestes
                Termos sobrevivem à rescisão.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Isenção de responsabilidade.
                {' '}
                Os Serviços são fornecidos como uma ferramenta de comunicação.
                Você deve sempre verificar as informações obtidas dos Serviços
                com a fonte adequada antes de realizar qualquer atividade. Você
                é responsável por garantir a precisão das informações derivadas
                dos Serviços e assume todos os riscos associados ao seu uso.
                Você é responsável por seguir todas as leis e regulamentações
                federais, estaduais e locais, incluindo, mas não se limitando
                a, leis e regulamentações relacionadas ao uso de fertilizantes,
                pesticidas e outros insumos agrícolas. Você deve sempre seguir
                o rótulo ao aplicar qualquer pesticida. Se você não concordar
                com as seguintes cláusulas de Não Garantia e Indenização, sua
                única solução será interromper o uso dos Serviços.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Sem garantia.
                {' '}
                <u>
                  O AGSAFE NÃO FORNECE NENHUMA GARANTIA EXPRESSA OU IMPLÍCITA REFERENTE A (1) OS
                  SERVIÇOS; (2) O CONTEÚDO, PRECISÃO, MOEDA OU INTEGRIDADE DAS SUBMISSÕES DO
                  USUÁRIO, ou (3)
                  INFORMAÇÕES EXIBIDAS NO MAPA AGSAFE. O AGSAFE ISENTA-SE DE TODAS AS GARANTIAS
                  COM RESPEITO AOS SERVIÇOS, INCLUINDO QUAISQUER GARANTIAS IMPLÍCITAS DE
                  COMERCIALIZAÇÃO,
                  NÃO VIOLAÇÃO DE DIREITOS DE TERCEIROS, LIBERDADE DE VÍRUS OU
                  OUTRO CÓDIGO PREJUDICIAL,
                  OU ADEQUAÇÃO A UM DETERMINADO FIM.

                </u>
                {' '}
                O AGSAFE não garante que o uso dos Serviços irá reduzir
                o risco de aplicação incorreta
                de pesticidas, deriva ou volatilização. Você não pode confiar nos
                Serviços como a única
                fonte de informações ao tomar decisões. Os Serviços
                também podem incluir informações
                imprecisas, incluindo informações imprecisas relativas
                a insectioníduos, organizações,
                campos, plantações, híbridos e variedades de sementes, características, insumos de
                safras, atividades de produção agrícola e comunicação.
                O uso de qualquer informação
                ou Envio do usuário é por sua própria conta e risco. Se você acredita que as
                informações contidas nos Serviços são imprecisas, notifique o AGSAFE o mais
                rápido possível.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Indenização.
                {' '}
                Você concorda em indenizar e defender AGSAFE,
                incluindo seus diretores, funcionários
                , agentes, oficiais, desenvolvedores e licenciadores,
                de quaisquer danos, custos,
                reivindicações, lesões e responsabilidades
                (incluindo honorários advocatícios)
                decorrentes do seu uso dos Serviços, incluindo
                qualquer pessoa que use os Serviços
                em seu nome, como um funcionário. Em nenhuma
                circunstância AGSAFE será responsável
                por quaisquer danos consequenciais, incidentais, especiais, indiretos ou punitivos
                decorrentes do seu uso dos Serviços (incluindo, sem limitação, danos por perda de
                negócios ou boa vontade, paralisação do trabalho,
                fora do alvo ou aplicação incorreta
                de proteção à colheita produtos, perda de informações
                ou dados, perda de receita ou
                lucro ou falha do computador.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Modificações.
                {' '}
                O AGSAFE pode revisar estes Termos de tempos em tempos. AGSAFE irá notificá-lo,
                quando você entrar nos Serviços, ou por outro meio, quando estes
                Termos forem revisados.
                Ao continuar a usar os Serviços após as revisões entrarem em vigor, você
                concorda em obedecer a quaisquer Termos revisados.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Outros termos legais.
                {' '}
                Os Termos são regidos pela lei do Brasil. Qualquer processo que nomeie AGSAFE
                (incluindo qualquer empresa ou marca afiliada,
                proprietários, funcionários, advogados
                ou agentes) como uma parte envolvendo estes
                Termos deve ser apresentado nos tribunais
                estaduais e federais do Brasil, e você concorda
                com local e jurisdição. Estes Termos
                não criam direitos de terceiros beneficiários. A falha do AGSAFE em fazer cumprir
                qualquer disposição destes Termos não é uma renúncia ao direito de fazê-lo em
                uma data posterior.
                Se alguma cláusula for considerada inexequível, as cláusulas
                restantes do Contrato
                permanecerão em pleno vigor. Você não pode atribuir sua
                conta ou qualquer um de seus
                direitos nestes Termos. AGSAFE pode ceder seus direitos
                sem o seu consentimento. Estes
                Termos não criam um relacionamento de funcionário,
                parceria ou agência entre você e
                o AGSAFE.
              </p>
            </li>
            <li className=" text-justify">
              <p>
                Observe.
                {' '}
                Se você precisar entrar em contato com o AGSAFE para
                qualquer propósito relacionado a
                estes Termos, envie um e-mail para info@agsafe.com.br.
              </p>
            </li>

            <span className="text-justify">Ao salvar meu cadastro, declaro que as informações que forneci são precisas e verdadeiras e que li e compreendi a isenção de responsabilidade e os termos de utilização acima.</span>
          </section>
          <div className="modal-footer">
            {!show && <button type="button" data-dismiss="modal" className="btn btn-dark">Fechar</button>}
            {show
            && (
            <>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, terms: false,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Não Aceito os Termos
              </button>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, terms: true,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Aceito os Termos
              </button>
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export function Suporte() {
  return (
    <div className="modal fade" id="modal-suporte" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">Suporte AGSAFE</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <form id="contatoForm" method="get" action="mailto:admin@agsafe.com.br" target="_blank">
              <input id="subject" onChange="" name="Subject" type="text" className="form-control my-2" placeholder="Informe o assunto" />
              <textarea rows="6" maxLength="600" id="subject" onChange="" name="Body" type="text" className="form-control ml-1 my-2" placeholder="Digite sua mensagem" />
              <button id="enviar" className="btn btn-dark ml-1" value="click" type="submit">Enviar Mensagem</button>
            </form>
          </section>
          <div className="modal-footer">
            <button type="button" data-dismiss="modal" className="btn btn-dark">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
}
export function PoliticaDEProvacidade({ aceite: { show } }) {
  const { setAcepted } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-politica-de-privacidade" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">Política de Privacidade AGSAFE</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <p className="text-justify">
              Nós, da AGSAFE TECNOLOGIA E SERVIÇOS LTDA, empresa controladora do site
              AGSAFE e app AGSAFE, CNPJ: 01.122.069/0001-42
              , estamos comprometidos em resguardar sua privacidade. O intuito deste
              documento é esclarecer quais informações são coletadas dos usuários de nossos sites http://agsafe.com.br; https://agsafeapp.com e respectivos serviços e de que forma esses dados são manipulados e utilizados.
            </p>
            <p className="text-justify">Para oferecer nossos serviços, a AGSAFE, por meio de seu site, de seu aplicativo e do, coleta sectionersos dados e informações, visando, sobretudo, proporcionar uma experiência cada vez melhor para você. A AGSAFE reconhece que a sua privacidade é muito importante, portanto tomamos todas as medidas possíveis para protegê-la. Nesse sentido, a presente Política de Privacidade (“Política”) visa lhe informar como as suas informações e dados serão coletados, usados, compartilhados e armazenados por meio dos nossos sites e respectivos serviços.</p>
            <p className="text-justify mt-2">Este documento é parte integrante do nosso Termo de Uso, que contém uma visão geral da nossa plataforma.</p>
            <p className="text-justify"><u>Este documento foi redigido de forma simples e acessível, justamente para que você possa ler e entender a forma como utilizamos os seus dados para lhe oferecer uma experiência segura e confortável na prestação dos nossos serviços.</u></p>
            <p className="text-justify">A aceitação da nossa Política será feita quando você se cadastrar em nossa plataforma para usufruir dos nossos serviços, mesmo que de forma gratuita. Isso indicará que você está ciente e em total acordo com a forma como utilizaremos as suas informações e seus dados.</p>
            <p className="text-justify">Caso não concorde com esta Política, por favor, não continue o seu procedimento de registro e não use os nossos serviços. Todavia, por favor, nos informe a sua discordância para que possamos melhorá-los.</p>
            <sp className="text-justify">A presente Política está sectionidida da seguinte forma para facilitar a sua compreensão:</sp>
            <ul>
              <li className="">Sobre a coleta de dados</li>
              <li className="">Sobre o uso de seus dados pessoais</li>
              <li className="">Sobre o acesso aos seus dados pessoais</li>
              <li className="">Sobre o compartilhamento de dados</li>
              <li className="">Sobre o uso de informações fornecidas aos nossos usuários</li>
              <li className="">Sobre o cancelamento da assinatura e alteração/exclusão de informações pessoais</li>
              <li className="">Mudanças na Política de Privacidade</li>
            </ul>
            <span>Lei Aplicável</span>
            <p className="text-justify">Qualquer dúvida em relação à nossa política de privacidade pode ser esclarecida entrando em contato conosco, envie um e-mail para info@agsafe.com.br</p>
            <span className="text-justify">Sobre a coleta de dados</span>
            <p className="text-justify">
              <u>Informações fornecidas por você</u>
              <br />
              Coletamos informações de identificação pessoal como nome, telefone, e-mail, empresa
              em que trabalha, cargo, nome empresarial, CNPJ, localização da propriedade, cultura
              produzida, informações sobre certificação de qualidade (orgânicos, IBD).
              Eventualmente, a solicitação de algumas informações pode ser feita por meio de
              contato direto da AGSAFE com os usuários via e-mail ou telefone.
            </p>
            <span className="text-justify"><u>Informações de navegação no site</u></span>
            <p className="text-justify">Quando você visita nosso site, é inserido um ‘cookie’ no seu navegador por meio do software Google Analytics, para identificar quantas vezes você retorna ao nosso endereço. São coletadas informações como endereço IP, localização geográfica, fonte de referência, tipo de navegador, duração da visita e páginas visitadas.</p>
            <span className="text-justify">Histórico de contato</span>
            <p className="text-justify">Aqui na AGSAFE armazenamos informações a respeito de todos os contatos já realizados com nossos usuários, como localizações informadas e demais dados solicitados no início do cadastro. </p>
            <span className="text-justify"><u>Dados gerados na utilização de nossos serviços</u></span>
            <p className="text-justify">Se você utilizar de algum de nossos serviços, coletaremos ainda outras informações suas. Nesse caso, coletaremos dados de contato como seu nome, e-mail e telefone, dados locacionais como país, cidade e estado de onde o acesso está ocorrendo, dados de perfil profissional, incluindo cargo, nome e segmento da empresa onde você trabalha, número de funcionários dessa empresa, formação acadêmica e anos de experiência.</p>
            <span className="text-justify">Sobre o uso de seus dados pessoais</span>
            <p className="text-justify">Todos os dados que coletamos são utilizados para a prestação de nossos serviços, e não custa lembrar, prezamos muito a sua privacidade. Por isso, todos os dados e informações sobre você são tratadas como confidenciais, e somente usaremos os dados relacionados a empresa informada no cadastro para os fins aqui descritos e autorizados por você, principalmente para que você possa utilizar nossos serviços de forma plena, visando sempre melhorar a sua experiência como usuário. Desta forma, poderemos personalizar o serviço para se adequar cada vez mais aos seus gostos e interesses. Ademais, seus dados também podem ser utilizados para criarmos novos serviços, produtos e funcionalidades.</p>
            <p className="text-justify mt-3">Eventualmente, poderemos utilizar dados para finalidades não previstas nesta política de privacidade, mas estas estarão dentro das suas legítimas expectativas. O eventual uso dos seus dados para finalidades que não cumpram com essa prerrogativa será feito mediante sua autorização prévia.</p>
            <p className="text-justify"><u>Além do acima informado, utilizaremos seus dados para as seguintes finalidades:</u></p>

            <ul>
              <li className=" text-justify">Seu e-mail é utilizado para a operação de envio de notificações sobre aplicação de defensivos próximas a localização da propriedade rural informada. Também pode ser usado para envio de Newsletters, relacionadas ao tema Defensivos Agrícolas. O e-mail será utilizado ainda para comunicar o lançamento de novos materiais gratuitos ou de novos produtos da AGSAFE e parceiros. No entanto, o usuário pode cancelar a assinatura a qualquer momento;</li>
              <li className=" text-justify">Os dados de localização e culturas produzidas poderão ser sectionulgados como pesquisas e estatísticas, não sendo reveladas abertamente nenhuma informação pessoal, a menos que autorizada explicitamente;</li>
              <li className=" text-justify">Funcionários da AGSAFE poderão eventualmente entrar em contato via e-mail ou telefone para fazer pesquisas ou apresentar produtos e serviços;</li>
              <li className=" text-justify">Enviar a você mensagens a respeito de suporte ou serviço, como alertas, notificações e atualizações. Além do envio de mensagem em caso de incidência de aplicação de defensivos na localidade da empresa/propriedade rural informada;</li>
              <li className=" text-justify">Comunicar sobre produtos, serviços, promoções, notícias, atualizações, eventos e outros assuntos que você possa ter interesse; Realizar publicidade direcionada conforme seus gostos, interesses e outras informações coletadas;</li>
              <li className=" text-justify">Personalizar o serviço para que este seja cada vez mais adequado aos seus gostos e interesses;</li>
              <li className=" text-justify">Para outros fins desde que autorizado por você no momento da coleta de dados;</li>
              <li className=" text-justify">Cumprir obrigações legais.</li>
            </ul>

            <p className="text-justify">A AGSAFE se reserva no direito de monitorar toda a plataforma, principalmente para assegurar que as regras descritas em nosso Termo de Uso estão sendo observadas, ou ainda, se não há violação ou abuso das leis aplicáveis. Portanto, a AGSAFE se reserva no direito de excluir determinado usuário, independentemente do tipo que for, caso a presente Política não seja respeitada.</p>
            <p className="text-justify">Sobre o acesso aos seus dados pessoais</p>
            <p className="text-justify">Poderão ver suas informações pessoais apenas funcionários da AGSAFE, e dentre estes, somente as pessoas com as devidas autorizações. Eventualmente, caso a inserção de suas informações se dê em ações criadas em parcerias, os parceiros explicitamente identificados também terão acesso à informação. Nenhum dado pessoal poderá ser sectionulgado publicamente.</p>
            <p className="text-justify">Todos os seus dados são confidenciais e qualquer uso destes estará de acordo com a presente Política. A AGSAFE empreenderá todos os esforços razoáveis de mercado para garantir a segurança dos nossos sistemas e dos seus dados. Nossos servidores estão localizados em diferentes locais do mundo para garantir sua estabilidade e segurança, e somente podem ser acessados por meio de canais de comunicação previamente autorizados.</p>
            <p className="text-justify mt-3">Todas as suas informações serão, sempre que possível, criptografadas, caso não inviabilizem o seu uso pela AGSAFE. A qualquer momento você poderá requisitar cópia dos seus dados armazenados em nossos sistemas. Manteremos os dados e informações somente até quando estas forem necessárias ou relevantes para as finalidades descritas nesta Política, ou em caso de períodos pré-determinados por lei, ou até quando estas forem necessárias para a manutenção de interesses legítimos da AGSAFE.</p>
            <span className="text-justify">Sobre o compartilhamento de dados</span>
            <p className="text-justify">Ao clicar nos botões de cadastro/novo cadastro de localização da sua empresa/propriedade rural, o usuário estará publicando a localização do seu estabelecimento. Sendo este compartilhado com demais usuários da plataforma ou app AGSAFE. Os usuários não tem acesso ao login e senha dos usuários, bem como, não possuem acesso aos dados pessoais informados no cadastro. Para fins de cumprimento dos nossos serviços e proposito da AGSAFE será compartilhado com outros usuários somente a localização da propriedade rural, certificações de qualidade e cultura produzida. </p>
            <p className="text-justify">Por ser uma plataforma online, a AGSAFE poderá operar em conjunto de outras empresas numa ampla gama de atividades. Desta forma, nos reservamos no direito de compartilhar suas informações, incluindo dados de localização, cadastro e de interesses, com nossos parceiros, anunciantes e provedores de serviços, sempre que for possível, de forma anônima, visando preservar a sua privacidade. Por meio deste documento, você autoriza expressamente tais compartilhamentos.</p>
            <p className="text-justify">Todavia, a AGSAFE não se responsabiliza pelos atos, anúncios e conteúdos gerados por nossos parceiros comerciais e redes de anúncio, e esta Política não se aplica a eles, uma vez que a AGSAFE não as controla.</p>
            <p className="text-justify">Todos os dados, informações e conteúdos sobre você podem ser considerados ativos no caso de negociações em que a AGSAFE fizer parte. Portanto, nos reservamos no direito de incluir seus dados dentre os ativos da empresa caso esta venha a ser vendida, adquirida ou fundida com outra. Por meio desta Política você concorda e está ciente desta possibilidade.</p>
            <p className="text-justify mt-2">A AGSAFE se reserva no direito de fornecer seus dados e informações sobre você, incluindo interações suas, caso seja requisitado judicialmente para tanto, ato necessário para que a empresa esteja em conformidade com as leis nacionais, ou caso você autorize expressamente.</p>
            <span className="text-justify">Sobre o uso de informações fornecidas aos nossos usuários</span>
            <p className="text-justify">A AGSAFE disponibiliza aos seus usuários, por meio do APP e Site AGSAFE.COM.BR, ferramentas para localização de propriedades rurais e suas respectivas culturas, objetivando o compartilhamento com aplicadores afim de trazer segurança nas operações de aplicações aéreas e terrestres de defensivos agrícolas. </p>
            <p className="text-justify mt-2">No entanto, a AGSAFE não controla as informações utilizadas por seus usuários. A utilização dos dados devem ter como proposito a criação de um ambiente seguro para aplicação de defensivos agrícolas. </p>
            <p className="text-justify">Sobre o cancelamento da assinatura e alteração/exclusão de informações pessoais</p>
            <p className="text-justify">Você pode optar por não receber mais qualquer tipo de e-mail da AGSAFE. Em todos os e-mails que enviamos há sempre um link para cancelar a assinatura disponível nas últimas linhas. Ao clicar nesse link, você será automaticamente descadastrado da lista.</p>
            <p className="text-justify">É importante mencionar que, ao preencher um novo formulário ficará caracterizada a reinserção do seu e-mail à lista. Portanto, a requisição de cancelamento deve ser feita novamente, caso seja de seu interesse.</p>
            <p className="text-justify">Todos os dados coletados serão excluídos de nossos servidores quando você assim requisitar ou quando estes não forem mais necessários ou relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer outra razão para a sua manutenção, como eventual obrigação legal de retenção de dados ou necessidade de preservação destes para resguardo de direitos da AGSAFE. Para alterar suas informações pessoais ou excluí-las do nosso banco de dados, basta enviar um e-mail para contato@agsafe.com.br  </p>
            <span className="text-justify">Mudanças na Política de Privacidade</span>
            <p className="text-justify">Essa Política de Privacidade pode passar por atualizações. Desta forma, recomendamos visitar periodicamente esta página para que você tenha conhecimento sobre as modificações. Caso sejam feitas alterações relevantes que ensejem novas autorizações suas, publicaremos uma nova política de privacidade.</p>
            <p className="text-justify mt-2">Antes de usar informações para outros fins que não os definidos nesta Política de Privacidade, solicitaremos sua autorização.</p>
            <span className="text-justify">Lei Aplicável</span>
            <p className="text-justify">Este documento é regido e deve ser interpretado de acordo com as leis da República Federativa do Brasil. Fica eleito o Foro da Comarca de São Paulo como o competente para dirimir quaisquer questões porventura oriundas do presente documento, com expressa renúncia a qualquer outro, por mais privilegiado que seja.</p>

          </section>
          <div className="modal-footer">
            {!show && <button type="button" data-dismiss="modal" className="btn btn-dark">Fechar</button>}
            {show
            && (
            <>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, privacity: false,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Não Aceito as Políticas
              </button>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, privacity: true,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Aceito as Políticas
              </button>
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export function PoliticaDeProvacidadeInicial({ aceite: { show } }) {
  const { setAcepted } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-politica-de-privacidade-i" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLongTitle">Política de Privacidade AGSAFE</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <p className="text-justify">
              Nós, da AGSAFE TECNOLOGIA E SERVIÇOS LTDA, empresa controladora do site
              AGSAFE e app AGSAFE, CNPJ: 01.122.069/0001-42
              , estamos comprometidos em resguardar sua privacidade. O intuito deste
              documento é esclarecer quais informações são coletadas dos usuários de nossos sites http://agsafe.com.br; https://agsafeapp.com e respectivos serviços e de que forma esses dados são manipulados e utilizados.
            </p>
            <p className="text-justify">Para oferecer nossos serviços, a AGSAFE, por meio de seu site, de seu aplicativo e do, coleta sectionersos dados e informações, visando, sobretudo, proporcionar uma experiência cada vez melhor para você. A AGSAFE reconhece que a sua privacidade é muito importante, portanto tomamos todas as medidas possíveis para protegê-la. Nesse sentido, a presente Política de Privacidade (“Política”) visa lhe informar como as suas informações e dados serão coletados, usados, compartilhados e armazenados por meio dos nossos sites e respectivos serviços.</p>
            <p className="text-justify mt-2">Este documento é parte integrante do nosso Termo de Uso, que contém uma visão geral da nossa plataforma.</p>
            <p className="text-justify"><u>Este documento foi redigido de forma simples e acessível, justamente para que você possa ler e entender a forma como utilizamos os seus dados para lhe oferecer uma experiência segura e confortável na prestação dos nossos serviços.</u></p>
            <p className="text-justify">A aceitação da nossa Política será feita quando você se cadastrar em nossa plataforma para usufruir dos nossos serviços, mesmo que de forma gratuita. Isso indicará que você está ciente e em total acordo com a forma como utilizaremos as suas informações e seus dados.</p>
            <p className="text-justify">Caso não concorde com esta Política, por favor, não continue o seu procedimento de registro e não use os nossos serviços. Todavia, por favor, nos informe a sua discordância para que possamos melhorá-los.</p>
            <sp className="text-justify">A presente Política está sectionidida da seguinte forma para facilitar a sua compreensão:</sp>
            <ul>
              <li className="">Sobre a coleta de dados</li>
              <li className="">Sobre o uso de seus dados pessoais</li>
              <li className="">Sobre o acesso aos seus dados pessoais</li>
              <li className="">Sobre o compartilhamento de dados</li>
              <li className="">Sobre o uso de informações fornecidas aos nossos usuários</li>
              <li className="">Sobre o cancelamento da assinatura e alteração/exclusão de informações pessoais</li>
              <li className="">Mudanças na Política de Privacidade</li>
            </ul>
            <span>Lei Aplicável</span>
            <p className="text-justify">Qualquer dúvida em relação à nossa política de privacidade pode ser esclarecida entrando em contato conosco, envie um e-mail para info@agsafe.com.br</p>
            <span className="text-justify">Sobre a coleta de dados</span>
            <p className="text-justify">
              <u>Informações fornecidas por você</u>
              <br />
              Coletamos informações de identificação pessoal como nome, telefone, e-mail, empresa
              em que trabalha, cargo, nome empresarial, CNPJ, localização da propriedade, cultura
              produzida, informações sobre certificação de qualidade (orgânicos, IBD).
              Eventualmente, a solicitação de algumas informações pode ser feita por meio de
              contato direto da AGSAFE com os usuários via e-mail ou telefone.
            </p>
            <span className="text-justify"><u>Informações de navegação no site</u></span>
            <p className="text-justify">Quando você visita nosso site, é inserido um ‘cookie’ no seu navegador por meio do software Google Analytics, para identificar quantas vezes você retorna ao nosso endereço. São coletadas informações como endereço IP, localização geográfica, fonte de referência, tipo de navegador, duração da visita e páginas visitadas.</p>
            <span className="text-justify">Histórico de contato</span>
            <p className="text-justify">Aqui na AGSAFE armazenamos informações a respeito de todos os contatos já realizados com nossos usuários, como localizações informadas e demais dados solicitados no início do cadastro. </p>
            <span className="text-justify"><u>Dados gerados na utilização de nossos serviços</u></span>
            <p className="text-justify">Se você utilizar de algum de nossos serviços, coletaremos ainda outras informações suas. Nesse caso, coletaremos dados de contato como seu nome, e-mail e telefone, dados locacionais como país, cidade e estado de onde o acesso está ocorrendo, dados de perfil profissional, incluindo cargo, nome e segmento da empresa onde você trabalha, número de funcionários dessa empresa, formação acadêmica e anos de experiência.</p>
            <span className="text-justify">Sobre o uso de seus dados pessoais</span>
            <p className="text-justify">Todos os dados que coletamos são utilizados para a prestação de nossos serviços, e não custa lembrar, prezamos muito a sua privacidade. Por isso, todos os dados e informações sobre você são tratadas como confidenciais, e somente usaremos os dados relacionados a empresa informada no cadastro para os fins aqui descritos e autorizados por você, principalmente para que você possa utilizar nossos serviços de forma plena, visando sempre melhorar a sua experiência como usuário. Desta forma, poderemos personalizar o serviço para se adequar cada vez mais aos seus gostos e interesses. Ademais, seus dados também podem ser utilizados para criarmos novos serviços, produtos e funcionalidades.</p>
            <p className="text-justify mt-3">Eventualmente, poderemos utilizar dados para finalidades não previstas nesta política de privacidade, mas estas estarão dentro das suas legítimas expectativas. O eventual uso dos seus dados para finalidades que não cumpram com essa prerrogativa será feito mediante sua autorização prévia.</p>
            <p className="text-justify"><u>Além do acima informado, utilizaremos seus dados para as seguintes finalidades:</u></p>

            <ul>
              <li className=" text-justify">Seu e-mail é utilizado para a operação de envio de notificações sobre aplicação de defensivos próximas a localização da propriedade rural informada. Também pode ser usado para envio de Newsletters, relacionadas ao tema Defensivos Agrícolas. O e-mail será utilizado ainda para comunicar o lançamento de novos materiais gratuitos ou de novos produtos da AGSAFE e parceiros. No entanto, o usuário pode cancelar a assinatura a qualquer momento;</li>
              <li className=" text-justify">Os dados de localização e culturas produzidas poderão ser sectionulgados como pesquisas e estatísticas, não sendo reveladas abertamente nenhuma informação pessoal, a menos que autorizada explicitamente;</li>
              <li className=" text-justify">Funcionários da AGSAFE poderão eventualmente entrar em contato via e-mail ou telefone para fazer pesquisas ou apresentar produtos e serviços;</li>
              <li className=" text-justify">Enviar a você mensagens a respeito de suporte ou serviço, como alertas, notificações e atualizações. Além do envio de mensagem em caso de incidência de aplicação de defensivos na localidade da empresa/propriedade rural informada;</li>
              <li className=" text-justify">Comunicar sobre produtos, serviços, promoções, notícias, atualizações, eventos e outros assuntos que você possa ter interesse; Realizar publicidade direcionada conforme seus gostos, interesses e outras informações coletadas;</li>
              <li className=" text-justify">Personalizar o serviço para que este seja cada vez mais adequado aos seus gostos e interesses;</li>
              <li className=" text-justify">Para outros fins desde que autorizado por você no momento da coleta de dados;</li>
              <li className=" text-justify">Cumprir obrigações legais.</li>
            </ul>

            <p className="text-justify">A AGSAFE se reserva no direito de monitorar toda a plataforma, principalmente para assegurar que as regras descritas em nosso Termo de Uso estão sendo observadas, ou ainda, se não há violação ou abuso das leis aplicáveis. Portanto, a AGSAFE se reserva no direito de excluir determinado usuário, independentemente do tipo que for, caso a presente Política não seja respeitada.</p>
            <p className="text-justify">Sobre o acesso aos seus dados pessoais</p>
            <p className="text-justify">Poderão ver suas informações pessoais apenas funcionários da AGSAFE, e dentre estes, somente as pessoas com as devidas autorizações. Eventualmente, caso a inserção de suas informações se dê em ações criadas em parcerias, os parceiros explicitamente identificados também terão acesso à informação. Nenhum dado pessoal poderá ser sectionulgado publicamente.</p>
            <p className="text-justify">Todos os seus dados são confidenciais e qualquer uso destes estará de acordo com a presente Política. A AGSAFE empreenderá todos os esforços razoáveis de mercado para garantir a segurança dos nossos sistemas e dos seus dados. Nossos servidores estão localizados em diferentes locais do mundo para garantir sua estabilidade e segurança, e somente podem ser acessados por meio de canais de comunicação previamente autorizados.</p>
            <p className="text-justify mt-3">Todas as suas informações serão, sempre que possível, criptografadas, caso não inviabilizem o seu uso pela AGSAFE. A qualquer momento você poderá requisitar cópia dos seus dados armazenados em nossos sistemas. Manteremos os dados e informações somente até quando estas forem necessárias ou relevantes para as finalidades descritas nesta Política, ou em caso de períodos pré-determinados por lei, ou até quando estas forem necessárias para a manutenção de interesses legítimos da AGSAFE.</p>
            <span className="text-justify">Sobre o compartilhamento de dados</span>
            <p className="text-justify">Ao clicar nos botões de cadastro/novo cadastro de localização da sua empresa/propriedade rural, o usuário estará publicando a localização do seu estabelecimento. Sendo este compartilhado com demais usuários da plataforma ou app AGSAFE. Os usuários não tem acesso ao login e senha dos usuários, bem como, não possuem acesso aos dados pessoais informados no cadastro. Para fins de cumprimento dos nossos serviços e proposito da AGSAFE será compartilhado com outros usuários somente a localização da propriedade rural, certificações de qualidade e cultura produzida. </p>
            <p className="text-justify">Por ser uma plataforma online, a AGSAFE poderá operar em conjunto de outras empresas numa ampla gama de atividades. Desta forma, nos reservamos no direito de compartilhar suas informações, incluindo dados de localização, cadastro e de interesses, com nossos parceiros, anunciantes e provedores de serviços, sempre que for possível, de forma anônima, visando preservar a sua privacidade. Por meio deste documento, você autoriza expressamente tais compartilhamentos.</p>
            <p className="text-justify">Todavia, a AGSAFE não se responsabiliza pelos atos, anúncios e conteúdos gerados por nossos parceiros comerciais e redes de anúncio, e esta Política não se aplica a eles, uma vez que a AGSAFE não as controla.</p>
            <p className="text-justify">Todos os dados, informações e conteúdos sobre você podem ser considerados ativos no caso de negociações em que a AGSAFE fizer parte. Portanto, nos reservamos no direito de incluir seus dados dentre os ativos da empresa caso esta venha a ser vendida, adquirida ou fundida com outra. Por meio desta Política você concorda e está ciente desta possibilidade.</p>
            <p className="text-justify mt-2">A AGSAFE se reserva no direito de fornecer seus dados e informações sobre você, incluindo interações suas, caso seja requisitado judicialmente para tanto, ato necessário para que a empresa esteja em conformidade com as leis nacionais, ou caso você autorize expressamente.</p>
            <span className="text-justify">Sobre o uso de informações fornecidas aos nossos usuários</span>
            <p className="text-justify">A AGSAFE disponibiliza aos seus usuários, por meio do APP e Site AGSAFE.COM.BR, ferramentas para localização de propriedades rurais e suas respectivas culturas, objetivando o compartilhamento com aplicadores afim de trazer segurança nas operações de aplicações aéreas e terrestres de defensivos agrícolas. </p>
            <p className="text-justify mt-2">No entanto, a AGSAFE não controla as informações utilizadas por seus usuários. A utilização dos dados devem ter como proposito a criação de um ambiente seguro para aplicação de defensivos agrícolas. </p>
            <p className="text-justify">Sobre o cancelamento da assinatura e alteração/exclusão de informações pessoais</p>
            <p className="text-justify">Você pode optar por não receber mais qualquer tipo de e-mail da AGSAFE. Em todos os e-mails que enviamos há sempre um link para cancelar a assinatura disponível nas últimas linhas. Ao clicar nesse link, você será automaticamente descadastrado da lista.</p>
            <p className="text-justify">É importante mencionar que, ao preencher um novo formulário ficará caracterizada a reinserção do seu e-mail à lista. Portanto, a requisição de cancelamento deve ser feita novamente, caso seja de seu interesse.</p>
            <p className="text-justify">Todos os dados coletados serão excluídos de nossos servidores quando você assim requisitar ou quando estes não forem mais necessários ou relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer outra razão para a sua manutenção, como eventual obrigação legal de retenção de dados ou necessidade de preservação destes para resguardo de direitos da AGSAFE. Para alterar suas informações pessoais ou excluí-las do nosso banco de dados, basta enviar um e-mail para contato@agsafe.com.br  </p>
            <span className="text-justify">Mudanças na Política de Privacidade</span>
            <p className="text-justify">Essa Política de Privacidade pode passar por atualizações. Desta forma, recomendamos visitar periodicamente esta página para que você tenha conhecimento sobre as modificações. Caso sejam feitas alterações relevantes que ensejem novas autorizações suas, publicaremos uma nova política de privacidade.</p>
            <p className="text-justify mt-2">Antes de usar informações para outros fins que não os definidos nesta Política de Privacidade, solicitaremos sua autorização.</p>
            <span className="text-justify">Lei Aplicável</span>
            <p className="text-justify">Este documento é regido e deve ser interpretado de acordo com as leis da República Federativa do Brasil. Fica eleito o Foro da Comarca de São Paulo como o competente para dirimir quaisquer questões porventura oriundas do presente documento, com expressa renúncia a qualquer outro, por mais privilegiado que seja.</p>

          </section>
          <div className="modal-footer">
            {!show && <button type="button" data-dismiss="modal" className="btn btn-dark">Fechar</button>}
            {show
            && (
            <>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, privacity: false,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Não Aceito as Políticas
              </button>
              <button
                onClick={() => {
                  setAcepted((prevState) => ({
                    ...prevState, privacity: true,
                  }));
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Aceito as Políticas
              </button>
            </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export function Mensagens() {
  const {
    message: { selected }, title, setMessage, setTitle,
  } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-mensagens" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            {selected
              ? <span className="modal-title" id="exampleModalLongTitle">{`Título: ${title}`}</span>
              : <span className="modal-title" id="exampleModalLongTitle">{title}</span>}
            <button
              onClick={() => {
                setMessage({ message: {}, selected: false });
                setTitle('Minhas Mensagens');
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <Inbox />
          </section>
          {!selected
            && (
            <div className="modal-footer">
              <button
                onClick={() => {
                  setMessage({ message: {}, selected: false });
                  setTitle('Minhas Mensagens');
                }}
                type="button"
                data-dismiss="modal"
                className="btn btn-dark"
              >
                Fechar
              </button>
            </div>
            )}
        </div>
      </div>
    </div>
  );
}
export function Certificado(props) {
  return (
    <div className="modal fade" id="modal-certificado" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered  modal" role="document">
        <div className="modal-content">
          <section className="modal-body">
            <ModalCertificado elemento={props} />
          </section>
        </div>
      </div>
    </div>
  );
}
export function ListarVendas() {
  return (
    <div className="modal fade" id="modal-vendas" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Visualizar Vendas</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <ModalVendas />
          </section>
          <div className="modal-footer">
            <button
              type="button"
              data-dismiss="modal"
              className="btn btn-dark btn-sm"
            >
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export function NotificarUsuario() {
  // const {
  //   message: { selected }, title, setMessage, setTitle,
  // } = useContext(UsuarioContext);
  return (
    <div className="modal fade" id="modal-notificar" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Notificar Usuários</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <NotificarUsuarios />
          </section>
        </div>
      </div>
    </div>
  );
}
export function AtribuirNovo() {
  return (
    <div className="modal fade" id="modal-atribuir" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Gerênciar Culturas Ativas</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <AtribuirNovoCadastro />
          </section>
        </div>
      </div>
    </div>
  );
}
export function AdicionarExpetador() {
  return (
    <div className="modal fade" id="modal-apresentar" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Adicionar Expectador</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <Apresentar />
          </section>
        </div>
      </div>
    </div>
  );
}
export function CadastrosAtivos() {
  return (
    <div className="modal fade" id="modal-cadastros-ativos" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Cadastros ativos</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <Cadastros />
          </section>
        </div>
      </div>
    </div>
  );
}
export function CadastrosAtivosAdmin() {
  return (
    <div className="modal fade" id="modal-cadastros-ativos-admin" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Administrar Cadastros Ativos</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <CadastrosAdmin />
          </section>
        </div>
      </div>
    </div>
  );
}
export function CadastrosInativosAdmin() {
  return (
    <div className="modal fade" id="modal-cadastros-inativos-admin" tabIndex="-1" role="dialog" aria-labelledby="modal-logoutTitle" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <span className="modal-title" id="exampleModalLongTitle">Administrar Cadastros Inativos</span>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <section className="modal-body">
            <CadastrosInAdmin />
          </section>
        </div>
      </div>
    </div>
  );
}

TermosDeUso.propTypes = {
  aceite: PropTypes.shape({
    show: PropTypes.bool,
    setAcepted: PropTypes.func,
  }).isRequired,
};
